module.exports = __webpack_public_path__ + "static/media/seo.a11e1df8.svg";